import { RouteRecordRaw } from 'vue-router';

const ctx = require.context('@/pages', true, /\.(page\.tsx?)$/);

export const routes = ctx
  .keys()
  .flatMap((path) => Object.values(ctx(path)) as RouteRecordRaw[]);
